<template>
  <div>
    <p><br /></p>
    <form id="demo" method="post">
      <!-- text -->
      <div class="form">
        <div class="form-content">
          <div class="form-row">
            <label>{{ label_first_name }}<span class="error">*</span></label>
            <input id="first_name" type="text" v-model.trim.lazy="$v.form.first_name.$model" />
            <p class="error" v-if="$v.form.first_name.$dirty && !$v.form.first_name.required">{{ label_required }}</p>
            <p class="error" v-if="!$v.form.first_name.minLength">{{ label_minchars }} {{ $v.form.last_name.$params.minLength.min }}</p>
          </div>
          <div class="form-row">
            <label>{{ label_last_name }}<span class="error">*</span></label>
            <input id="first_name" type="text" v-model.trim.lazy="$v.form.last_name.$model" />
            <p class="error" v-if="$v.form.last_name.$dirty && !$v.form.last_name.required">{{ label_required }}</p>
            <p class="error" v-if="!$v.form.last_name.minLength">{{ label_minchars }} {{ $v.form.last_name.$params.minLength.min }}</p>
          </div>
          <div class="form-row">
            <label>{{ label_email }}<span class="error">*</span></label><br>
            <input id="email" type="email" v-model.trim.lazy="$v.form.email.$model" />
            <p class="error" v-if="$v.form.email.$dirty && !$v.form.email.required">{{ label_required }}</p>
            <p class="error" v-if="!$v.form.email.email">{{ label_invalid }}</p>
          </div>
          <div class="form-row">
            <label>{{ label_address }}<span class="error">*</span></label><br>
            <input id="address" type="text" v-model.trim.lazy="$v.form.address.$model" />
            <p class="error" v-if="$v.form.address.$dirty && !$v.form.address.required">{{ label_required }}</p>
            <p class="error" v-if="!$v.form.address.minLength">{{ label_minchars }} {{ $v.form.address.$params.minLength.min }}</p>
          </div>
          <div class="form-row">
            <label>{{ label_suburb }}<span class="error">*</span></label><br>
            <input id="suburb" type="text" v-model.trim.lazy="$v.form.suburb.$model" />
            <p class="error" v-if="$v.form.suburb.$dirty && !$v.form.suburb.required">{{ label_required }}</p>
            <p class="error" v-if="!$v.form.suburb.minLength">{{ label_minchars }} {{ $v.form.suburb.$params.minLength.min }}</p>
          </div>
          <div class="form-row">
            <label>{{ label_state }}<span class="error">*</span></label><br>
            <select v-if="isAU" name="state" id="state" v-model.trim.lazy="$v.form.state.$model" required>
              <option value="" disabled>Select</option>
              <option value="NSW">NSW</option>
            </select>
            <select v-if="isUS" name="state" id="state" v-model.trim.lazy="$v.form.state.$model" required>
              <option value="" disabled>Select</option>
              <option value="CO">CO</option>
            </select>
            <input v-if="isGeneric" id="state" type="text" v-model.trim.lazy="$v.form.state.$model" />
            <p class="error" v-if="$v.form.state.$dirty && !$v.form.state.required">{{ label_required }}</p>
          </div>
          <div class="form-row">
            <label>{{ label_postcode }}<span class="error">*</span></label><br>
            <input id="postcode" type="text" v-model.trim.lazy="$v.form.postcode.$model" />
            <p class="error" v-if="$v.form.postcode.$dirty && !$v.form.postcode.required" >{{ label_required }}</p>
            <p class="error" v-if="!$v.form.postcode.minLength" >{{ label_minchars }} {{ $v.form.postcode.$params.minLength.min }}</p>
          </div>
          <div class="form-row">
            <label>{{ label_phone }}<span class="error">*</span></label><br>
            <input id="phone" type="text" v-model.trim.lazy="$v.form.phone.$model" />
            <p class="error" v-if="$v.form.phone.$dirty && !$v.form.phone.required">{{ label_required }}</p>
            <p class="error" v-if="!$v.form.phone.minLength">{{ label_minchars }} {{ $v.form.phone.$params.minLength.min }}</p>
          </div>
          <div class="form-row">
            <label>{{ label_vehicle }}<span class="error">*</span></label><br>
            <select v-model.lazy="$v.form.vehicle.$model" required>
              <option value="" disabled>Select</option>
              <option v-for="(vehicle, index) in vehicles" :key="vehicle['name']" :value="vehicle['name']">{{ vehicle['name'] }}</option>
              <option value="other">Other</option>
            </select>
            <p class="error" v-if="$v.form.vehicle.$dirty && !$v.form.vehicle.required">{{ label_required }}</p>
          </div>
          <div class="form-row">
            <label>{{ label_vehicle_colour }}<span class="error">*</span></label><br>
            <input id="vehicle_colour" type="text" v-model.trim.lazy="form.vehicle_colour" />
          </div>
          <div v-if="formHasAttachments">
            <div class="form-row">
                <label>Side {{ label_image_validation_rules }}<span class="error">*</span></label>
                <input type="file" id="side_image" :accept="imageMimeTypes" @change.prevent="validateFile($event)"> 
                  <p class="error" v-if="fileInputErrors && fileInputErrors.side_image">{{ fileInputErrors.side_image }}</p>
            </div>
            <div class="form-row">
                <label>Front {{ label_image_validation_rules }}<span class="error">*</span></label>
                <input type="file" id="front_image" :accept="imageMimeTypes" @change.prevent="validateFile($event)"> 
                <p class="error" v-if="fileInputErrors && fileInputErrors.front_image">{{ fileInputErrors.front_image }}</p>
            </div>
            <div class="form-row">
                <label>Back {{ label_image_validation_rules }}<span class="error">*</span></label>
                <input type="file" id="back_image" :accept="imageMimeTypes" @change.prevent="validateFile($event)"> 
                  <p class="error" v-if="fileInputErrors && fileInputErrors.back_image">{{ fileInputErrors.back_image }}</p>
            </div>
            <div class="form-row">
                <label>Top {{ label_image_validation_rules }}<span class="error">*</span></label>
                <input type="file" id="top_image" :accept="imageMimeTypes" @change.prevent="validateFile($event)"> 
                <p class="error" v-if="fileInputErrors && fileInputErrors.top_image">{{ fileInputErrors.top_image }}</p>
            </div>
            <div class="form-row">
                <label>Compliance Plate {{ label_image_validation_rules }}<span class="error">*</span></label>
                <input type="file" id="compliance_plate_image" :accept="imageMimeTypes" @change.prevent="validateFile($event)">
                <p class="error" v-if="fileInputErrors && fileInputErrors.compliance_plate_image">{{ fileInputErrors.compliance_plate_image }}</p>
            </div>
          </div>
          <div class="form-row">
            <label>{{ label_modifications }}<span class="error">*</span></label><br>
            <textarea id="modifications" type="textarea" v-model.trim.lazy="form.modifications"></textarea>
          </div>
          <div>
            <input id="tnc" class="styled-checkbox" type="checkbox" v-model.trim.lazy="$v.form.tnc.$model" />
              <label v-if="isGeneric" for="tnc">{{ label_tnc }}<span class="error">*</span></label>
              <label v-if="!isGeneric" for="tnc"> 
                By clicking submit, you agree to our <a :href="`https://www.rhinorack.com/${culture}/privacy-and-personal-information-collection-statement`">Privacy Collection Statement</a> and the <a :href="`https://www.rhinorack.com/${culture}/vehicle-photo-shoot-terms-conditions`">Terms & Conditions</a> of participation.
                <span class="error">*</span>
              </label>
            <br>
            <p class="error" v-if="$v.form.tnc.$dirty && !$v.form.tnc.sameAs">{{ label_required }}</p>
          </div>
          <div>
            <input id="subscribe" class="styled-checkbox" type="checkbox" v-model.trim.lazy="form.subscribe" />
            <label for="subscribe">{{ label_subscribe }}<span class="error"></span></label><br>
            <!-- <p class="error" v-if="$v.form.tnc.$dirty && !$v.form.tnc.sameAs">{{ label_required }}</p> -->
          </div>
          <p><br></p>
          <div>
            <vue-recaptcha
              sitekey="6LdWQtwUAAAAAKNZMGCJABPG3JzVsTmsobH_kCOR"
              :loadRecaptchaScript="true"
              @error="error"
              @expired="expired"
              @verify="verify"
            ></vue-recaptcha>
          </div>
          
          <p><br></p>
            <button class="btn btn-hover btn-primary submit-form" :disabled="form_submitting" @click.prevent="submit()" v-if="verified === true && !form_submitted && (this.form.state && this.form.vehicle && this.form.tnc)">Submit</button>
            <p v-if="form_submitted">{{ label_form_submitted }}</p>
          </div>
        </div>

      
      


      <p><br /></p>
      <p><br /></p>
    </form>
  </div>
</template>
<script>
import { required, minLength, email, sameAs } from "vuelidate/lib/validators";
import VueRecaptcha from "vue-recaptcha";

export default {
  components: { VueRecaptcha },
  validations: {
    form: {
      first_name: {
        required,
        minLength: minLength(2)
      },
      last_name: {
        required,
        minLength: minLength(2)
      },
      email: {
        required,
        email
      },
      address: {
        required,
        minLength: minLength(2)
      },
      suburb: {
        required,
        minLength: minLength(2)
      },
      state: {
        required,
      },
      postcode: {
        required,
        minLength: minLength(2)
      },
      phone: {
        required,
        minLength: minLength(2)
      },
      vehicle: {
        required,
      },
      tnc: {
        required,
        sameAs: sameAs(() => true)
      },
    }
  },
  props: {
    label_first_name: {
      type: String,
      required: true,
      default: "First Name"
    },
    label_last_name: {
      type: String,
      required: true,
      default: "Last Name"
    },
    label_email: {
      type: String,
      required: true,
      default: "Email"
    },
    label_address: {
      type: String,
      required: true,
      default: "Address"
    },
    label_suburb: {
      type: String,
      required: true,
      default: "Suburb"
    },
    label_state: {
      type: String,
      required: true,
      default: "State"
    },
    label_postcode: {
      type: String,
      required: true,
      default: "Postcode"
    },
    label_phone: {
      type: String,
      required: true,
      default: "Phone"
    },
    label_vehicle: {
      type: String,
      required: true,
      default: "Select Your Vehicle"
    },
    label_vehicle_colour: {
      type: String,
      required: true,
      default: "Vehicle Colour"
    },
    label_modifications: {
      type: String,
      required: true,
      default:
        "Please list any modifications your vehicle has which alter it's appearance (eg. stickers, signage, snorkel, bull bar, body kit, non standard tyres)?"
    },
    label_tnc: {
      type: String,
      required: true,
      default: "I agree to the terms and conditions"
    },
    label_subscribe: {
      type: String,
      required: true,
      default:
        "Tick this box if you would like to be added to Rhino-Rack's email list - you will be kept up to date on our latest products, special promotions and news."
    },
    label_required: {
      type: String,
      required: true,
      default: "Required"
    },
    label_minchars: {
      type: String,
      required: true,
      default: "Minimum characters, "
    },
    label_invalid: {
      type: String,
      required: true,
      default: "Invalid"
    },
    label_form_submitted: {
      type: String,
      required: true,
      default: "Form Submitted"
    },
    label_image_validation_rules: {
      type: String,
      default: "(Image files only - png, jpeg, gif, jpg)"
    },
    has_attachments: {
      type: Number,
      default: 0,
    },
    disable_automated_email: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      verified: false,
      vehicles: false,
      form_submitting: false,
      form_submitted: false,
      form: {
        first_name: "",
        last_name: "",
        email: "",
        address: "",
        suburb: "",
        state: "",
        postcode: "",
        phone: "",
        vehicle: "",
        vehicle_colour: "",
        modifications: "",
        side_image: "",
        front_image: "",
        back_image: "",
        top_image: "",
        compliance_plate_image: "",
        tnc: false,
        subscribe: false
      },
      fileInputErrors: {},
      allowedExtensions: ['image/png','image/jpeg','image/gif','image/jpg','application/pdf','application/msword','application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
      imageMimeTypes: "image/png, image/jpeg, image/gif, image/jpg, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf"
    };
  },
  mounted() {
    if(!this.formHasAttachments) {
        for(let key of Object.keys(this.form)) {
            if (key.indexOf('_image') > 0) {
              this.$delete(this.form, key);
            }
        } 
    } 

    this.getVehicles();
    if(this.selectedVehicle)
    {
      this.form.vehicle = this.selectedVehicle;  
    }    
  },
  methods: {
    expired(value) {
      this.verified = false;
    },
    verify(value) {
      this.verified = true;
    },
    error(value) { 
      this.verified = false;
    },
    async submit() {
      let vm = this;
      this.$v.form.$touch();

      if (this.$v.form.$pending || this.$v.form.$error) {
        return;
      }

      let formData = new FormData();

      for (const key in this.form) {
        if(key.indexOf('_image') > 0 && this.formHasAttachments) {
          let file = $("#" + key).prop("files")[0]; 
            if (file) {
               formData.append(key, file);
            } else {
              this.$set(this.fileInputErrors, key, this.label_required);
            }
        } else {
          formData.append(key, vm.form[key]);
        }
      }

      formData.append('disable_automated_email', this.disable_automated_email);

      if (this.verified === true && Object.keys(vm.fileInputErrors).length == 0) {
        this.form_submitting = true;
        // to form submit after this
        let response = await axios.post(`api/bookingForm`, formData);
        // console.log('response', response)

        if (response.data.data === true && response.data.success === true) {
          this.form_submitted = true;
          this.form_submitting = false;
        }else{
          this.form_submitted = false;
          this.form_submitting = false;
        }


      }
    },
    async getVehicles() {
      let response = await axios.get(`api/vehicles`, this.form);
      if (response.data.success === true) {
        this.vehicles = response.data.data;
      }
    },
    validateFile(event) {
      let elementId = event.target.id;
      let file = $("#" + elementId).prop("files")[0];
      if(file) {
        this.$delete(this.fileInputErrors, elementId);

        if( !this.allowedExtensions.includes(file["type"]) ) {
          $("#" + elementId).val(null);
          this.$set(this.fileInputErrors, elementId,  "The selected file type is not supported");
        } else if (file["size"]  > 2097152) {
          $("#" + elementId).val(null);
          this.$set(this.fileInputErrors, elementId, "The selected file size is too big");
        }
      } else {
        this.$set(this.fileInputErrors, elementId, this.label_required);
      }
    }
  },
  computed: {
    selectedVehicle() {
      return this.$store.state.solutions.selectedVehicle.full_name;
    },
    formHasAttachments() {
      return this.has_attachments == 1 ? true : false;
    },
    culture() {
      return window.culture ?? 'en-au';
    },
    isAU() {
      return this.culture == 'en-au';
    },
    isUS() {
      return this.culture == 'en-us';
    },
    isGeneric() {
      return !['en-us', 'en-au'].includes(this.culture);
    }
  }
};
</script>

<style scoped>
.form { padding: 20px; border: 1px solid #eaeaea; }
.form .form-content { position: relative; }
.form .form-content .form-row { margin-bottom: 25px; }
.form .form-content .form-row label { margin-bottom: 5px; }
.form .form-content .form-row select,
.form .form-content .form-row input {
  width: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 10px 15px;
  border-radius: 0;
  border: 1px solid #eaeaea;
  color: #212529;
}
.form .form-content .form-row textarea {
  width: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 10px 15px;
  border-radius: 0;
  border: 1px solid #eaeaea;
  color: #212529;
  resize: none;
}
.form .form-content .styled-checkbox {
  position: absolute;
  opacity: 0;
}
.form .form-content .styled-checkbox + label {
  position: relative;
  cursor: pointer;
  padding: 0;
}
.form .form-content .styled-checkbox + label:before {
  content: '';
  margin-right: 10px;
  display: inline-block;
  vertical-align: text-top;
  width: 20px;
  height: 20px;
  background: #fff;
}
.form .form-content .styled-checkbox:hover + label:before {
  background: #005cb9;
}
.form .form-content .styled-checkbox:focus + label:before {
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.15);
}
.form .form-content .styled-checkbox:checked + label:before {
  background: #005cb9;
}
.form .form-content .styled-checkbox:checked + label:after {
  content: '';
  position: absolute;
  left: 5px;
  top: 9px;
  background: #fff;
  width: 2px;
  height: 2px;
  box-shadow: 
    2px 0 0 #fff,
    4px 0 0 #fff,
    4px -2px 0 #fff,
    4px -4px 0 #fff,
    4px -6px 0 #fff,
    4px -8px 0 #fff;
  transform: rotate(45deg);
}
.form .form-content .submit-form {
  max-width: 320px;
  width: 100%;
}
</style>